import { TRecursiveNonNullable } from '@api/Helper.types';
import { GetProductOffersResponse } from '@iwoca/lapi-client/edge';

export type TProductOffersDocRequirementType =
    TRecursiveNonNullable<GetProductOffersResponse>['data']['products'][number]['data_requirements'][number]['type'];

export const getSuggestedProduct = (
    productOffers: GetProductOffersResponse['data']
) => {
    return productOffers!.products.find((product) => product.is_suggested)!;
};

export const getOptionalDataRequirements = (
    suggestedProduct: ReturnType<typeof getSuggestedProduct>,
    supportedDocuments: TProductOffersDocRequirementType[]
) => {
    return suggestedProduct.data_requirements.filter(
        (requirement) =>
            supportedDocuments.includes(
                requirement.type as TProductOffersDocRequirementType
            ) && requirement.is_optional
    );
};
